import CONSTANTS from '../../../config/constants';
import BaseOverlay from './BaseOverlay';

const SessionTransferred = ({ lastConnectionChange, size = 'large', iconSize = 'large', titleVariant = 'h2', padding = 'large', showExpandedInfo = true }) => {
  const extractData = (lastConnectionChange, attachedToProctorRoomSid) => {
    const isTransferredIn = lastConnectionChange?.metadata?.toProctorRoomSid === attachedToProctorRoomSid;

    return {
      title: isTransferredIn ? "Transferred In" : "Transferred Out",
      buttonText: isTransferredIn ? "View Session" : "Dismiss Message",
      iconName: isTransferredIn ? "IconToggleStartLine" : "IconExternalLinkLine",
      note: lastConnectionChange?.metadata?.note || null,
      alertTitle: "Transfer Note",
      alertVariant: "info",
      iconColor: "success"
    };
  };

  return (
    <BaseOverlay
      lastConnectionChange={lastConnectionChange}
      size={size}
      iconSize={iconSize}
      titleVariant={titleVariant}
      padding={padding}
      showExpandedInfo={showExpandedInfo}
      ttlConstant={CONSTANTS.OVERLAYS.SESSION.TRANSFERRED.TTL}
      onDataExtract={extractData}
    />
  );
};

export default SessionTransferred;
